import { FC, memo } from 'react'
import MockOrderData from 'components/MockData/MockOrderData'

import OrderCargoBlockForm from '../OrderGuestCreateForm/OrderCargoBlockForm'
import { OrderGuestRoutesDateBlockForm } from '../OrderGuestCreateForm/OrderGuestRoutesDateBlockForm'
import { OrderGuestSummary } from './OrderGuestSummary'

interface OrderGuestCreateFormProps {
  className?: string
  isShowPhone?: boolean
}

export const OrderGuestCreateForm: FC<OrderGuestCreateFormProps> = ({ className, isShowPhone }) => (
  <div className={className}>
    <div className="mb-12 min-[701px]:mb-0">
      <OrderGuestRoutesDateBlockForm />
      <OrderCargoBlockForm />
    </div>
    <div className="relative">
      <OrderGuestSummary
        className="mt-4 grid grid-cols-1 content-start gap-y-4 min-[701px]:sticky min-[701px]:top-[20px] min-[701px]:pl-6"
        isShowPhone={isShowPhone}
      />
    </div>
    <MockOrderData />
  </div>
)

export default memo(OrderGuestCreateForm)
